<template>
  <div
    :class="[
      'field-component',
      field.type,
      !isValid && initialised ? 'with-errors' : ''
    ]"
  >
    <p class="help-text" v-if="field.helpText">
      {{ $t(field.helpText, `helpText`, translationContext) }}
    </p>
    <label v-if="label !== ''"
      >{{ $t(label, `label`, translationContext)
      }}<span v-if="isRequiredField" class="required">*</span></label
    >
    <div class="input-wrapper">
      <input
        :tabindex="tabindex"
        @keyup="onKeyUp($event)"
        v-if="field.type == 'text'"
        :autocomplete="field.autocomplete"
        :name="name"
        :placeholder="field.placeholder"
        type="text"
        @input="updateOption(name, $event)"
        v-model="localValue"
        class="field-text"
        ref="input"
      />
      <textarea
        v-if="field.type == 'textarea'"
        class="field-textarea"
        @keyup="updateOption(name, $event)"
        v-model="localValue"
      ></textarea>
      <div v-if="field.type == 'trix'">
        <input
          type="hidden"
          class="field-trix"
          :id="'trix-' + name"
          @change="updateOption(name, $event)"
          v-model="localValue"
        />
        <trix-editor
          ref="trixfield"
          :placeholder="field.placeholder"
          @trix-change="trixUpdate"
          :input="'trix-' + name"
        ></trix-editor>
      </div>

      <div v-if="field.type == 'color'" class="field-preview--color">
        <ion-icon
          class="remove-color"
          @click="nullValue"
          name="close"
        ></ion-icon>
        <div class="field-preview--swatch" @click.prevent="togglePicker">
          <div
            class="field-preview--with-color"
            v-if="localValue"
            :style="{ backgroundColor: localValue }"
          ></div>
          <div class="field-preview--without-color" v-if="!localValue"></div>
        </div>
        <color-picker
          :disable-alpha="false"
          @input="onColorChange($event)"
          v-if="showPicker"
          v-model="colors"
        ></color-picker>
      </div>

      <!--<input @keyup='onKeyUp($event)' v-if='field.type == "color"' :name='name' :placeholder='field.placeholder' type="color" @input='updateOption(name, $event)' v-model='localValue' class='field-text' ref='input'/>-->
      <div v-if="field.type == 'radio'" class="field-radio">
        <span class="option" v-for="(opt, i) in field.options" :key="opt.label">
          <input
            type="radio"
            :tabindex="tabindex"
            :name="name"
            v-bind:value="opt.value"
            v-model="localValue"
            @click="updateOption(name, $event)"
          />
          <span class="option-label">{{
            $t(opt.label, `options.${i}.label`, translationContext)
          }}</span>
        </span>
      </div>

      <div v-if="field.type == 'checkbox'" class="field-radio">
        <label v-for="(opt, i) in field.options" :key="opt.label">
          <input
            type="checkbox"
            :tabindex="tabindex"
            :name="name"
            v-bind:value="opt.value"
            v-model="localValue"
            @click="updateOption(name, $event)"
          />
          <span
            v-html="$t(opt.label, `options.${i}.label`, translationContext)"
          ></span>
        </label>
      </div>

      <select
        v-model="localValue"
        v-if="field.type == 'select'"
        :name="name"
        @change="updateOption(name, $event)"
        class="field-select"
        :tabindex="tabindex"
      >
        <option :value="null" v-if="!field.skipChoose">{{
          $t(field.placeholder, "placeholder", translationContext)
        }}</option>
        <option
          v-for="(option, i) in field.options"
          :key="mappedOption(option).label"
          :value="mappedOption(option).value"
          >{{
            $t(option.label, `options.${i}.label`, translationContext)
          }}</option
        >
      </select>
    </div>

    <transition name="short-fade">
      <div
        class="field-errors"
        v-if="
          field.type !== 'repeatable' &&
            errors.length > 0 &&
            initialised &&
            showErrors
        "
      >
        <span class="arrow-left"></span>
        <ul>
          <li v-for="error in errors" :key="error">
            <span
              v-html="
                $t(
                  error,
                  error.toLowerCase().replace(/\s/g, '-'),
                  translationContext
                )
              "
            ></span>
          </li>
        </ul>
      </div>
    </transition>
    <span class="tooltip" :data-tippy-content="$t(tooltip)" v-if="tooltip"
      ><i class="fa fa-info-circle"></i
    ></span>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import Validations from "../lib/ValidationMixin";
import Utilities from "../lib/Utilities";
import _ from "lodash";
import { Chrome } from "vue-color";
import TranslationMixin from "../lib/TranslationMixin";

export default {
  name: "field",
  props: {
    tabindex: { default: "1" },
    translationContext: { default: null, type: String },
    field: { default: null, type: Object },
    group: { default: null, type: String },
    name: { default: null, type: String },
    label: { default: "", type: String },
    value: { default: null, type: [String, Boolean, Array, Number, File] },
    validateWith: { default: null, type: [Function, Object] },
    debounce: { default: 300, type: Number },
    uploadPath: { default: "", type: String },
    deletePath: { default: "", type: String },
    tooltip: { default: "", type: String },
    showErrors: { default: true, type: Boolean }
  },
  mixins: [Validations, TranslationMixin],
  components: {
    "color-picker": Chrome
  },
  data() {
    return {
      localValue: null,
      isValid: false,
      errors: [],
      showPicker: false,
      initialised: false,
      colors: {
        hex: "#194d33"
      }
    };
  },
  computed: {
    isRequiredField() {
      return Utilities.dig(this.field, ["validate", "required"], false);
    }
  },
  methods: {
    nullValue() {
      if (this.field.type === "color") {
        this.localValue = "#00000000";
        this.updateOption(this.name);
      } else {
        this.localValue = null;
      }
    },
    togglePicker() {
      this.showPicker = !this.showPicker;
      if (this.showPicker) {
        setTimeout(() => {
          window.addEventListener("click", this.clickListener);
        }, 250);
      }
    },
    clickListener(event) {
      let tgt = event.target;
      if (this.showPicker && tgt.closest(".vc-chrome") === null) {
        this.showPicker = false;
        window.removeEventListener("click", this.clickListener);
      }
    },
    onColorChange(event) {
      this.localValue = this.colors.hex8;
      this.updateOption(this.name);
    },
    mappedOption(option) {
      if (typeof this.field.optionMap == "undefined" || !this.field.optionMap) {
        return option;
      } else {
        return {
          label: option[this.field.optionMap.label],
          value: option[this.field.optionMap.value]
        };
      }
    },
    focus() {
      this.$refs.input.focus();
    },
    onKeyUp(event) {
      if (event.code == "Enter") {
        this.$emit("enter", event);
      }
    },
    updateRepeatableField(name, list) {
      this.localValue = list;
      Vue.nextTick(() => {
        let payload = { value: this.localValue, name: this.name };
        this.$emit("change", payload);
      });
    },
    trixUpdate(ev) {
      this.localValue = ev.target.value;
      this.initialised = true;
      this.validityCheck(ev.target.innerText);
    },
    updateValue(newValue) {
      this.localValue = newValue;
    },
    validateLocal() {
      this.initialised = true;
      this.validityCheck(this.localValue);
    },
    validityCheck(value) {
      Vue.nextTick(
        function() {
          let validityCheck = this.validateValue(this.validateWith, value);

          let valid = validityCheck.result;
          this.errors = validityCheck.errors;
          if (valid !== this.isValid) {
            this.isValid = valid;
            this.$emit("validityChange", {
              valid: this.isValid,
              name: this.name,
              target: this,
              errors: this.errors,
              group: this.group
            });
          }
          let payload = {
            value: this.localValue,
            name: this.name,
            group: this.group,
            target: this
          };
          if (this.initialised === true) {
            this.$emit("change", payload);
          }
        }.bind(this)
      );
    },
    updateFileField(name, event) {
      let payload = {
        file: event.target.files[0],
        name: this.name,
        group: this.group,
        target: this
      };
      this.$emit("change", payload);
    },
    deleteFileField(name, event) {
      let payload = {
        target: this,
        path: this.localValue,
        name: this.name,
        filename: Utils.basename(this.localValue),
        group: this.group
      };
      this.$emit("delete", payload);
    },
    updateOption(name, event) {
      _.debounce(
        function(name, event) {
          this.initialised = true;
          this.validityCheck(this.localValue);
        }.bind(this),
        this.debounce
      )();
    }
  },
  created() {
    if (
      (this.value === "" || this.value === null) &&
      typeof this.field.default !== "undefined"
    ) {
      this.localValue = this.field.default;
      let payload = {
        value: this.field.default,
        name: this.name,
        group: this.group,
        target: this
      };
      this.$emit("change", payload);
    } else {
      this.localValue = this.value;
    }
    if (this.field.type === "color") {
      this.colors = { hex: this.localValue };
    }
    this.debouncedMethod = function(fn) {
      return _.debounce(fn, this.debounce);
    };
  },
  mounted() {
    let validityValue = this.localValue;
    if (this.field.type == "trix") {
      validityValue = this.$refs.trixfield.innerText;
    }
    this.validityCheck(validityValue);
  }
};
</script>
<style lang="scss">
@import "../scss/components/field";
</style>
